// extracted by mini-css-extract-plugin
module.exports = {"col":"Table_col__5-3EG","checkboxCol":"Table_checkboxCol__1eNUN","emailCol":"Table_emailCol__yotf8","actionCol":"Table_actionCol__1Px0Q"};